(() => {
const BR_CLOVER = {
  "enabled": true,
  "prefix": "br:clover:",
  "events": [
    "session_started",
    "page_engaged",
    "scroll_depth_reached",
    "exit_intent_detected",
    "rug_finder_started",
    "rug_finder_answered",
    "rug_finder_completed",
    "recommendation_viewed",
    "recommendation_clicked",
    "wishlist_save_clicked",
    "wishlist_item_saved",
    "wishlist_item_removed",
    "wishlist_viewed",
    "wishlist_shared",
    "shared_wishlist_visited",
    "popup_viewed",
    "popup_clicked",
    "popup_dismissed",
    "popup_submitted",
    "size_guide_clicked",
    "find_my_size_clicked",
    "find_my_size_answered",
    "find_my_size_completed",
    "product_variant_selected",
    "back_in_stock_alert_clicked",
    "back_in_stock_alert_requested",
    "section_interacted",
    "section_viewed",
    "cart_item_saved_for_later",
    "saved_for_later_item_removed",
    "search_result_clicked",
    "filter_applied",
    "filter_removed",
    "sort_applied",
    "referral_link_visited",
    "identity_identified",
    "list_item_clicked",
    "promotion_viewed",
    "promotion_clicked",
    "newsletter_subscribed",
    "menu_clicked",
    "related_collection_clicked",
    "story_link_clicked",
    "new_site_prompt_accepted"
  ],
  "legacy": {
    "rug_finder_start": "rug_finder_started",
    "rug_finder_results": "rug_finder_completed",
    "rug_finder": "rug_finder_completed",
    "addToWishlist": "wishlist_item_saved",
    "menu_click": "menu_clicked",
    "related_categories": "related_collection_clicked",
    "storyLinks": "story_link_clicked",
    "new_site_continue": "new_site_prompt_accepted"
  },
  "privateKeys": [
    "email",
    "phone",
    "firstname",
    "lastname",
    "address1",
    "address2",
    "zip",
    "postalcode",
    "billingaddress",
    "shippingaddress",
    "password",
    "token",
    "accesstoken",
    "cardnumber"
  ],
  "limits": {
    "retryMs": 250,
    "retries": 40,
    "pending": 50,
    "valueLength": 256,
    "depth": 3,
    "listLength": 20,
    "engagedSeconds": 10,
    "heartMemoryMs": 15000,
    "scrollDepths": [
      25,
      50,
      75,
      90
    ]
  }
};

const config = BR_CLOVER;
const limits = config.limits;
const HEART = '[data-widget-type="collection-wish-list-heart"]';
const BACK_IN_STOCK = '#klaviyoInStockButton, [class*="klaviyoInStockMessage"], .klaviyo-bis-trigger';
const PREDICTIVE = 'custom-search, predictive-search, [data-predictive-search]';
const SIZE_GUIDE = 'a[href*="rug-size-guide"]';
const WISHLIST_PAGE = '/pages/my-wishlist';
const NEWSLETTER_TAGS = 'input[name="contact[tags]"]';
const FORM_EVENTS = {
  open: 'popup_viewed',
  embedOpen: 'popup_viewed',
  close: 'popup_dismissed',
  submit: 'popup_submitted',
  stepSubmit: 'popup_submitted',
  redirectedToUrl: 'popup_clicked',
};

const shop = () => {
  const analytics = window.Shopify && window.Shopify.analytics;
  return analytics && typeof analytics.publish === 'function' ? analytics : null;
};

const plainKey = (key) => String(key).toLowerCase().replace(/[^a-z0-9]/g, '');

const LAYER_KEYS = ['eventCallback', 'eventTimeout'];

const hidden = (key) =>
  config.privateKeys.indexOf(plainKey(key)) !== -1 ||
  key.indexOf('gtm.') === 0 ||
  LAYER_KEYS.indexOf(key) !== -1;

const clean = (value, depth) => {
  if (value === null || typeof value === 'boolean') return value;
  if (typeof value === 'number') return Number.isFinite(value) ? value : undefined;
  if (typeof value === 'string') return value.slice(0, limits.valueLength);
  if (typeof value !== 'object' || depth >= limits.depth) return undefined;
  if (Array.isArray(value)) {
    return value
      .slice(0, limits.listLength)
      .map((item) => clean(item, depth + 1))
      .filter((item) => item !== undefined);
  }
  const out = {};
  Object.keys(value).forEach((key) => {
    if (key === 'event' || hidden(key)) return;
    const next = clean(value[key], depth + 1);
    if (next !== undefined) out[key] = next;
  });
  return out;
};

const pending = [];
let tries = 0;

const deliver = (name, data) => {
  const analytics = shop();
  if (!analytics) return false;
  try {
    analytics.publish(config.prefix + name, data);
  } catch (error) {
    return true;
  }
  return true;
};

const drain = () => {
  if (!shop()) {
    tries += 1;
    if (tries <= limits.retries) setTimeout(drain, limits.retryMs);
    return;
  }
  pending.splice(0).forEach((item) => deliver(item[0], item[1]));
};

const publish = (name, data) => {
  if (!config.enabled || config.events.indexOf(name) === -1) return false;
  const payload = clean(data || {}, 0) || {};
  if (deliver(name, payload)) return true;
  if (pending.length >= limits.pending) return false;
  pending.push([name, payload]);
  if (pending.length === 1) setTimeout(drain, limits.retryMs);
  return true;
};

const sent = {};

const once = (key, name, data) => {
  if (sent[key]) return false;
  sent[key] = true;
  return publish(name, data);
};

const numberOf = (value) => {
  const parsed = parseFloat(String(value === undefined || value === null ? '' : value));
  return Number.isFinite(parsed) ? parsed : undefined;
};

const productContext = () => {
  const meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
  const product = meta && meta.product;
  return product && product.id ? { productId: String(product.id) } : {};
};

let lastHeart = null;

const heartContext = () => {
  if (!lastHeart || Date.now() - lastHeart.at > limits.heartMemoryMs) return {};
  return {
    productId: lastHeart.productId,
    variantId: lastHeart.variantId,
    url: lastHeart.url,
  };
};

const ENRICH = {
  wishlist_item_saved: (entry) =>
    Object.assign(heartContext(), {
      productName: entry.name,
      sku: entry.sku,
      variantTitle: entry.size,
      price: numberOf(entry.price),
    }),
};

const mirror = (entry) => {
  if (!entry || typeof entry !== 'object' || typeof entry.event !== 'string') return;
  if (!Object.prototype.hasOwnProperty.call(config.legacy, entry.event)) return;
  const target = config.legacy[entry.event];
  const enrich = ENRICH[target];
  publish(target, Object.assign({ legacy: entry.event }, enrich ? enrich(entry) : entry));
};

const watchLayer = () => {
  const layer = (window.dataLayer = window.dataLayer || []);
  layer.slice().forEach(mirror);
  const previous = layer.push;
  layer.push = function push() {
    const result = previous.apply(this, arguments);
    Array.prototype.forEach.call(arguments, mirror);
    return result;
  };
};

const checkedSort = () => {
  const input = document.querySelector('input[name="sort_by"]:checked');
  return input ? input.value : null;
};

const snapshot = () => {
  const params = new URLSearchParams(window.location.search);
  const filters = {};
  params.forEach((value, key) => {
    if (key.indexOf('filter.') !== 0) return;
    filters[key] = (filters[key] || []).concat(value);
  });
  return {
    path: window.location.pathname,
    filters,
    sort: params.get('sort_by') || checkedSort(),
    variant: params.get('variant'),
  };
};

let last = snapshot();

const compare = () => {
  const next = snapshot();
  const before = last;
  last = next;
  if (next.path !== before.path) return;
  const keys = Object.keys(Object.assign({}, before.filters, next.filters));
  keys.forEach((key) => {
    const was = before.filters[key] || [];
    const now = next.filters[key] || [];
    now
      .filter((value) => was.indexOf(value) === -1)
      .forEach((value) => publish('filter_applied', { filter: key, value, path: next.path }));
    was
      .filter((value) => now.indexOf(value) === -1)
      .forEach((value) => publish('filter_removed', { filter: key, value, path: next.path }));
  });
  if (next.sort && next.sort !== before.sort) {
    publish('sort_applied', { sort: next.sort, path: next.path });
  }
  if (next.variant && next.variant !== before.variant) {
    publish('product_variant_selected', Object.assign(productContext(), { variantId: next.variant }));
  }
};

const watchHistory = () => {
  ['pushState', 'replaceState'].forEach((method) => {
    const original = window.history[method];
    if (typeof original !== 'function') return;
    window.history[method] = function patched() {
      const result = original.apply(this, arguments);
      setTimeout(compare, 0);
      return result;
    };
  });
  window.addEventListener('popstate', compare);
};

const embedded = {};

const watchForms = () => {
  window.addEventListener('klaviyoForms', (event) => {
    const detail = (event && event.detail) || {};
    const target = FORM_EVENTS[detail.type];
    if (!target || !detail.formId) return;
    if (detail.type === 'embedOpen') embedded[detail.formId] = true;
    const meta = detail.metaData || {};
    const data = {
      formId: String(detail.formId),
      formTitle: typeof meta.$source === 'string' ? meta.$source : undefined,
      placement: embedded[detail.formId] ? 'embed' : 'popup',
      step: detail.type === 'stepSubmit' ? 'step' : undefined,
    };
    if (target === 'popup_submitted' && embedded[detail.formId] && detail.type === 'submit') {
      publish('newsletter_subscribed', { formId: data.formId, placement: 'embed' });
      return;
    }
    publish(target, data);
  });
};

const linkIndex = (link, scope) => {
  const links = Array.prototype.slice.call(scope.querySelectorAll('a[href*="/products/"]'));
  const index = links.indexOf(link);
  return index === -1 ? undefined : index + 1;
};

const onClick = (event) => {
  const target = event.target;
  if (!target || typeof target.closest !== 'function') return;
  const heart = target.closest(HEART);
  if (heart) {
    lastHeart = {
      productId: heart.getAttribute('data-product-id') || undefined,
      variantId: heart.getAttribute('data-variant-id') || undefined,
      url: heart.getAttribute('data-product-url') || undefined,
      at: Date.now(),
    };
    return;
  }
  if (target.closest(BACK_IN_STOCK)) {
    publish('back_in_stock_alert_clicked', productContext());
    return;
  }
  if (target.closest(SIZE_GUIDE)) {
    publish('size_guide_clicked', productContext());
    return;
  }
  const link = target.closest('a[href*="/products/"]');
  if (!link) return;
  const predictive = link.closest(PREDICTIVE);
  const onSearch = window.location.pathname.indexOf('/search') === 0;
  if (!predictive && !onSearch) return;
  const scope = predictive || document.querySelector('main') || document.body;
  const box = predictive && predictive.querySelector('input[type="search"], input[name="q"]');
  const query = box ? box.value : new URLSearchParams(window.location.search).get('q');
  publish('search_result_clicked', {
    source: predictive ? 'predictive' : 'results',
    query: query || undefined,
    position: linkIndex(link, scope),
    url: link.pathname,
  });
};

const onSubmit = (event) => {
  const form = event.target;
  if (!form || form.tagName !== 'FORM') return;
  const tags = form.querySelector(NEWSLETTER_TAGS);
  if (!tags || String(tags.value).indexOf('newsletter') === -1) return;
  const inFooter = typeof form.closest === 'function' && form.closest('footer');
  publish('newsletter_subscribed', { placement: inFooter ? 'footer' : 'page', path: window.location.pathname });
};

const onToggle = (event) => {
  const details = event.target;
  if (!details || details.tagName !== 'DETAILS') return;
  if (window.location.pathname.indexOf('/products/') === -1) return;
  const summary = details.querySelector('summary');
  const title = summary ? summary.textContent.replace(/\s+/g, ' ').trim() : '';
  if (!title) return;
  publish('section_interacted', Object.assign(productContext(), { section: title, open: details.open }));
};

const watchEngagement = () => {
  let seconds = 0;
  const timer = setInterval(() => {
    if (document.visibilityState !== 'visible') return;
    seconds += 1;
    if (seconds < limits.engagedSeconds) return;
    clearInterval(timer);
    once('engaged', 'page_engaged', { seconds, path: window.location.pathname });
  }, 1000);
  let queued = false;
  const measure = () => {
    queued = false;
    const doc = document.documentElement;
    const height = Math.max(doc.scrollHeight, document.body ? document.body.scrollHeight : 0);
    if (height <= 0) return;
    const reached = ((window.scrollY + window.innerHeight) / height) * 100;
    limits.scrollDepths.forEach((depth) => {
      if (reached >= depth) {
        once(`depth:${depth}`, 'scroll_depth_reached', {
          percent: depth,
          path: window.location.pathname,
        });
      }
    });
  };
  window.addEventListener(
    'scroll',
    () => {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(measure);
    },
    { passive: true },
  );
  document.addEventListener('mouseout', (event) => {
    if (event.relatedTarget || event.clientY > 0) return;
    once('exit', 'exit_intent_detected', { path: window.location.pathname });
  });
};

if (config.enabled && !window.brEvents) {
  window.brEvents = { publish };
  watchLayer();
  watchHistory();
  watchForms();
  watchEngagement();
  document.addEventListener('click', onClick, true);
  document.addEventListener('toggle', onToggle, true);
  document.addEventListener('submit', onSubmit, true);
  if (window.location.pathname === WISHLIST_PAGE) publish('wishlist_viewed', {});
}
})();
